import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { withStore } from "../store";
import { Service } from "../ApiService";
import Loader from "../Loader";
import DatePicker from "../DatePicker";
import SaveToExcelSVG from "../../svg/SaveToExcelSVG";
import { getFirstDayOfMonth, getLastDayOfMonth } from "../dateFunctions";
import DatePickerDropDown from "../DatePickerDropDown";
import CheckBox from "../CheckBox";
class VeteransAttendence extends Component {
  constructor(props) {
    super(props);
    var date = new Date();
    var date2 = new Date(date - 365 * 24 * 3600 * 1000);
    this.state = {
      data: [],
      loading: false,
      range: {
        start: date2,
        end: date,
      },
      active: false,
      lifestyleAttendanceRequirement: 15,
    };
    this.updateData = this.updateData.bind(this);
    this.donwloadExcel = this.donwloadExcel.bind(this);
    this.lifestyleFilter = this.lifestyleFilter.bind(this);
    this.datePickerRef = React.createRef();
  }
  updateData() {
    this.setState({ loading: true });
    Service.getVeteransAttendence(this.state.range).then((data) =>
      this.setState({ loading: false, data: data }),
    );
  }

  componentDidMount() {
    this.updateData();
  }

  donwloadExcel() {
    this.setState({ loading: true });
    const attendance = this.state.active
      ? this.state.lifestyleAttendanceRequirement
      : 0;
    Service.downloadWithPost("/api/Reports/VeteransAttandanceToExcel", {
      range: this.state.range,
      attendance: attendance,
    }).then((blob) => {
      Service.throwBlob(blob, "VeteransAttandance.xlsx");
    });
    this.setState({ loading: false });
  }
  lifestyleFilter() {
    // get new date range
    const today = new Date();
    const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
    const newRange = { start: endOfLastYear, end: today };
    this.setState({ range: newRange });

    // filter based on attendance
    const lifeStyleMembers = this.state.data.filter(
      (obj) => obj.attendance >= this.state.lifestyleAttendanceRequirement,
    );
    this.setState({ data: lifeStyleMembers });
  }

  render() {
    let total = 0;
    // similar to how they accumulated total, check which ones have more than 15
    this.state.data.forEach((a) => {
      total += a.attendance;
    });
    const columns = [
      { Header: "First Name", accessor: "firstName", filterable: true },
      { Header: "Last Name", accessor: "lastName", filterable: true },
      { Header: "Chapter", accessor: "chapter", filterable: true },
      { Header: "Address", accessor: "address", filterable: true },
      { Header: "Zip", accessor: "zip", filterable: true },
      {
        Header: (
          <span>
            Events Attended: <b>{total}</b>
          </span>
        ),
        accessor: "attendance",
        filterable: true,
      },
    ];
    return (
      <div>
        <div className="filter-nav-wrapper">
          <div className="filter-wrapper">
            <div className="flex-nowrap align-center">
              <span className="mr-05 uppercase-text">From:</span>
              <DatePicker
                value={this.state.range.start}
                maxDate={this.state.range.end}
                noClearButton={true}
                onSelect={(value) => {
                  var range = this.state.range;
                  range.start = value;
                  this.setState({ range: range });
                  setTimeout(this.updateData, 50);
                }}
              />
            </div>
            <div className="flex-nowrap align-center">
              <span className="mr-05 uppercase-text">To:</span>
              <DatePicker
                value={this.state.range.end}
                minDate={this.state.range.start}
                noClearButton={true}
                onSelect={(value) => {
                  var range = this.state.range;
                  range.end = value;
                  this.setState({ range: range });
                  setTimeout(this.updateData, 50);
                }}
              />
            </div>
          </div>
          <div className="lifestyle-wrapper">
            <CheckBox
              onClick={() => {
                this.state.active = !this.state.active;
                if (this.state.active) {
                  this.lifestyleFilter();
                } else {
                  const today = new Date();
                  const yearAgoToday = new Date(
                    new Date().setFullYear(new Date().getFullYear() - 1),
                  );
                  this.setState({
                    range: { start: yearAgoToday, end: today },
                  });
                  this.updateData();
                }
              }}
              checked={this.state.active}
            />
            <span>Lifestyle Vets</span>
          </div>
          <button
            className="round-button medium-round-button outline-on-hover"
            onClick={this.donwloadExcel}
          >
            <SaveToExcelSVG />
            <span>Excel</span>
          </button>
        </div>
        {this.state.loading && <Loader />}
        <h3 className="mr-05 ml-05 mt-2 mb-2 uppercase-text">
          <strong>Veteran's Attendance</strong> by Date Range
        </h3>
        {/*    {this.state.loading && <Loader />}
                <h1>Veteran's Attendance by Date Range</h1>
                <span>Date From:</span>
                <div style={{ display: "inline-block", width:"300px" }}>
                    <DatePicker
                        value={this.state.range.start}
                        maxDate={this.state.range.end}
                        ref={el => this.dateStartDropDownRef = el}
                        onSelect={value => {
                            var range = this.state.range;
                            range.start = value;
                            this.setState({ range: range });
                            setTimeout(this.updateData, 50);
                        }}
                    />
                </div>
                <span>Date To:</span>
                <div style={{ display: "inline-block", width: "300px" }}>
                <DatePicker
                    value={this.state.range.end}
                    minDate={this.state.range.start}
                    ref={el => this.dateEndDropDownRef = el}
                    onSelect={value => {
                        var range = this.state.range;
                        range.end = value;
                        this.setState({ range: range });
                        setTimeout(this.updateData, 50);
                    }}
                    />
                </div><button onClick={this.donwloadExcel}>Excel</button> */}
        <ReactTable data={this.state.data} columns={columns} />
      </div>
    );
  }
}
export default withStore(VeteransAttendence);



// WEBPACK FOOTER //
// ./src/components/reports/VeteransAttendence.jsx